import React from 'react';
import PropTypes from 'prop-types';

export function Wrapper(props) {
  const onDragOver = (event) => {
    event.preventDefault();
  };

  const onDrop = (event) => {
    event.preventDefault();
    if (props.onDrop) {
      props.onDrop(event);
    }
  };

  return (
    <div
      className={props.className}
      onDragOver={onDragOver}
      onDrop={onDrop}>
      {props.children}
    </div>
  );
}

Wrapper.propTypes = {
  /**
   * ClassName
   */
  className: PropTypes.string,
  /**
   * components to render in wrapper
   */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
  /**
   * function to invoke when option dropped
   */
  onDrop: PropTypes.func,
};

Wrapper.defaultProps = {
  className: '',
};
